// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1uHRY","inputDescription":"styles_inputDescription__3SdaM"};